import { render, staticRenderFns } from "./waterFall.edit.vue?vue&type=template&id=4c3a60fe&scoped=true"
import script from "./waterFall.edit.vue?vue&type=script&lang=js"
export * from "./waterFall.edit.vue?vue&type=script&lang=js"
import style0 from "./waterFall.edit.vue?vue&type=style&index=0&id=4c3a60fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a60fe",
  null
  
)

export default component.exports